import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';

import {
  InputField,
  SelectField,
  CheckboxField,
  DropdownField,
} from 'Common/SemanticWrapper';
import { TitledCard } from 'Components';
import { ITEM_MAINTENANCE_DETAIL_FORM_NAME, InputMode } from 'Common/FormEnum';
import { ItemMaintenanceEnum, FilterEnum } from 'Common/FieldEnum';
import { GenericFiltersContainer } from 'Components/filters/container';
import {
  getAcctCategoryForCurrentSite,
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getVendorForCurrentSite,
} from 'State/filters/actions';
import * as actions from '../state/addEditItem/actions';
import { getTaxGroupSetup } from './../../taxgroupsetup/state/actions';
import {
  makeOptionsDataWithEmpty as optionsWithEmpty,
  validateItemDetailFormData,
} from './../helpers';

import { makeOptionsDataWithEmpty } from 'Common/FormHelper';
import { ItemDetailTable } from './tables/ItemDetailsTable';

class ItemDetailsForm extends Component {
  state = {
    resetPageOnDataChange: true,
  };

  fields = [
    {
      name: FilterEnum.AlternateItemId,
      component: SelectField,
      type: 'text',
      options: optionsWithEmpty(this.props.altItems),
      label: 'Alternate Item',
    },
    {
      name: FilterEnum.GroupId_Cat,
      component: DropdownField,
      type: 'text',
      options: makeOptionsDataWithEmpty(this.props.acctCategoryData),
      label: 'Acct. Category',
      search: true,
      selection: true,
      fluid: true,
    },
    {
      name: FilterEnum.GroupId_Bid,
      component: SelectField,
      type: 'text',
      options: optionsWithEmpty(this.props.bidGroupData),
      label: 'Bid Group',
    },
    {
      name: FilterEnum.GroupId_Item,
      component: SelectField,
      type: 'text',
      options: optionsWithEmpty(this.props.itemGroupData),
      label: 'Item Group',
    },
    {
      name: FilterEnum.TaxGroupId,
      component: SelectField,
      type: 'text',
      options: optionsWithEmpty(this.props.taxGroupSetupData),
      label: 'Tax Group',
    },
    {
      name: ItemMaintenanceEnum.AllowPartialOrdering,
      component: CheckboxField,
      label: 'Allow Ordering Pack Qty',
      maxLength: 30,
      columnClassName: 'pt-50',
      toggle: true,
    },
    {
      name: ItemMaintenanceEnum.ActiveStatus,
      component: CheckboxField,
      label: 'Active',
      maxLength: 30,
      columnClassName: 'filterCheckboxClassName',
      toggle: true,
    },
  ];

  componentDidMount() {
    if (this.props.isSaveButtonClicked) {
      const { touch } = this.props;
      const toTouch = [];
      toTouch.push(ItemMaintenanceEnum.ItemCode);
      toTouch.push(ItemMaintenanceEnum.Description);
      toTouch.push(FilterEnum.GroupId_Cat);
      touch(...toTouch);
    }
  }
  onResetPageOnDataChange = () => {
    this.setState({ resetPageOnDataChange: false });
  };
  render() {
    const {
      id,
      handleSubmit,
      onHandItems,
      fetchingOnHands,
      isNew,
      gridPreferenceLoading,
      gridPreferenceSubmitting,
      handleItemDetailFieldChange,
      filterValues,
    } = this.props;

    return (
      <React.Fragment>
        <Form onSubmit={handleSubmit}>
          <Grid className="grid-spacing">
            <Grid.Row columns={3}>
              <Grid.Column>
                <Field
                  name={ItemMaintenanceEnum.ItemCode}
                  component={InputField}
                  type="text"
                  disabled={!isNew}
                  maxLength={20}
                  label={'Item Code'}
                  onChange={handleItemDetailFieldChange}
                />
              </Grid.Column>
              <Grid.Column style={{ flexGrow: 1 }}>
                <Field
                  name={ItemMaintenanceEnum.Description}
                  component={InputField}
                  type="text"
                  maxLength={60}
                  label={'Description'}
                  onChange={handleItemDetailFieldChange}
                />
              </Grid.Column>
            </Grid.Row>
            <GenericFiltersContainer
              fields={this.fields}
              filterValues={filterValues}
              onChange={handleItemDetailFieldChange}
            />

            <Grid.Row columns={3}>
              <Grid.Column>
                <Field
                  name={ItemMaintenanceEnum.MFRProductCode}
                  component={InputField}
                  type="text"
                  maxLength={200}
                  label={'MFR Product Code'}
                  mode={InputMode.Alphanumeric}
                  onChange={handleItemDetailFieldChange}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  name={ItemMaintenanceEnum.MFRName}
                  component={InputField}
                  type="text"
                  maxLength={200}
                  label={'MFR Name'}
                  onChange={handleItemDetailFieldChange}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  name={ItemMaintenanceEnum.MFRUrl}
                  component={InputField}
                  type="text"
                  maxLength={200}
                  label={'MFR URL'}
                  onChange={handleItemDetailFieldChange}
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row />
            <Grid.Row />
            <Grid.Row />
          </Grid>
          {+id ? (
            <TitledCard title={'On Hand'}>
              <Grid>
                <Grid.Row columns={1} className={'remove-spacing'}>
                  <Grid.Column>
                    <ItemDetailTable
                      fetchingOnHands={fetchingOnHands}
                      gridPreferenceLoading={gridPreferenceLoading}
                      gridPreferenceSubmitting={gridPreferenceSubmitting}
                      onHandItems={onHandItems}
                      resetPageOnDataChange={this.state.resetPageOnDataChange}
                      onResetPageOnDataChange={this.onResetPageOnDataChange}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </TitledCard>
          ) : null}
        </Form>
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => {
  const { gridPreference, filters } = state.CommonState;
  const { addEditItem } = state.ItemMaintenanceState;
  return {
    altItems: addEditItem.altItems,
    onHandItems: addEditItem.onHandItems,
    fetchingOnHands: addEditItem.fetchingOnHands,
    bidGroupData: filters.bidGroupData,
    itemGroupData: filters.itemGroupData,
    acctCategoryData: filters.acctCategoryData,
    taxGroupSetupData: state.TaxGroupSetupState.taxGroupSetupData,
    gridPreferenceLoading: gridPreference.loading,
    gridPreferenceSubmitting: gridPreference.isSubmitting,
  };
};
const mapDispatchToProps = {
  ...actions,
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getAcctCategoryForCurrentSite,
  getVendorForCurrentSite,
  getTaxGroupSetup,
};
ItemDetailsForm = connect(mapStateToProps, mapDispatchToProps)(ItemDetailsForm);

export default reduxForm({
  form: ITEM_MAINTENANCE_DETAIL_FORM_NAME,
  validate: validateItemDetailFormData,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
})(ItemDetailsForm);



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/components/ItemDetails.js